import { useCallback } from 'react';
import useSyncedStorage from './useSyncedStorage';
import { makeEntry, recordUse } from '../lib/songUsage';

const norm = (s) => String(s || '').toLowerCase().trim();

/**
 * The song usage log (synced per login) behind the CCLI report.
 * recordSongUse(title) is called when a song is sent live; the song's CCLI
 * number, if it has one in the library, is stored with the entry.
 */
export default function useSongUsage(songLibrary) {
  const [songUsage, setSongUsage] = useSyncedStorage('songUsage', (stored) => (Array.isArray(stored) ? stored : []));

  const recordSongUse = useCallback((title) => {
    const song = songLibrary.find(s => norm(s.title) === norm(title));
    const entry = makeEntry({ title, ccli: song && song.ccliNumber });
    setSongUsage(prev => recordUse(prev, entry));
  }, [songLibrary, setSongUsage]);

  const clearSongUsage = useCallback(() => setSongUsage([]), [setSongUsage]);

  return { songUsage, recordSongUse, clearSongUsage };
}
